/**
 * الأسعار والاشتراكات (لوحة التحكم التجارية، ADR-0018 §4a) بالعربية.
 * نفس مفاتيح billing.fr.ts، لغة المرجع.
 */
export const billingAr = {
  "billing.tabs.aria": "الأسعار والاشتراكات",
  "billing.tab.prices": "الأسعار",
  "billing.tab.promos": "العروض",
  "billing.tab.discounts": "التخفيضات",
  "billing.refreshFailed": "تعذّر تحديث القائمة: تظهر كما كانت.",
  "billing.anyPlan": "كل الخطط",
  "billing.planWithInterval": "{name}، الفوترة {interval}",
  "billing.interval.month": "شهريًا",
  "billing.interval.year": "سنويًا",
  "billing.window": "من {from} إلى {to}",
  "billing.window.endedEarly": "أوقفت في {date}",
  "billing.periods.whileSubscribed": "ما دام الاشتراك قائمًا",
  "billing.periods.count": "{count} فترات مدفوعة",
  "billing.state.scheduled": "مجدولة",
  "billing.state.running": "جارية",
  "billing.state.finished": "منتهية",
  "billing.state.ended_early": "أوقفت مبكرًا",
  "billing.scope.pro": "مهني واحد",
  "billing.scope.country": "بلد",
  "billing.scope.category": "مهنة",
  "billing.priceState.in_force": "ساري",
  "billing.priceState.scheduled": "مجدول",
  "billing.priceState.superseded": "مستبدل",
  "billing.prices.intro": "السعر الجديد يسري على الاشتراكات الجديدة فقط. ويحتفظ المهني بالسعر الذي اشترك به.",
  "billing.prices.loading": "جارٍ تحميل الأسعار…",
  "billing.prices.loadFailed": "تعذّر تحميل الأسعار.",
  "billing.prices.empty": "لم يُحدَّد أي سعر بعد.",
  "billing.prices.unpriced": "بلا سعر: {plans}. لا يمكن لأحد الاشتراك فيها.",
  "billing.prices.imported": "من المبلغ الأصلي للفئة",
  "billing.promos.intro":
    "يخفّض العرض سعر خطة في بلد لمن يشترك خلال نافذته. ويحصل المهني على أدنى سعر فقط: العرض والتخفيض لا يُجمعان.",
  "billing.promos.loading": "جارٍ تحميل العروض…",
  "billing.promos.loadFailed": "تعذّر تحميل العروض.",
  "billing.promos.empty": "لا عروض في الوقت الحالي.",
  "billing.discounts.intro":
    "التخفيض نسبة مئوية لمهني واحد أو بلد أو مهنة. ويحصل المهني على أدنى سعر فقط: التخفيض والعرض لا يُجمعان.",
  "billing.discounts.loading": "جارٍ تحميل التخفيضات…",
  "billing.discounts.loadFailed": "تعذّر تحميل التخفيضات.",
  "billing.discounts.empty": "لا تخفيضات في الوقت الحالي.",
  "billing.col.name": "الاسم",
  "billing.col.plan": "الخطة",
  "billing.col.country": "البلد",
  "billing.col.currency": "العملة",
  "billing.col.amount": "المبلغ",
  "billing.col.amountDue": "المتبقي للدفع",
  "billing.col.promoPrice": "سعر العرض",
  "billing.col.percentOff": "نسبة الخصم",
  "billing.col.periods": "المدة",
  "billing.col.window": "النافذة",
  "billing.col.state": "الحالة",
  "billing.col.status": "حالة الدفع",
  "billing.col.subscribers": "المهنيون المشمولون",
  "billing.col.createdBy": "أنشأها",
  "billing.col.setBy": "حدّده",
  "billing.col.reason": "السبب",
  "billing.col.validFrom": "اعتبارًا من",
  "billing.col.who": "لمن",
  "billing.col.actions": "الإجراءات",
  "billing.col.date": "التاريخ",
  "billing.col.period": "الفترة المغطاة",
  "billing.col.provider": "المزوّد",
  "billing.col.eventKind": "الحدث",
  "billing.col.via": "وصل عبر",
  "billing.col.result": "النتيجة",
  "billing.col.detail": "التفصيل",
  "billing.col.eventRef": "مرجع الحدث",
  "billing.action.setPrice": "تحديد سعر",
  "billing.action.newPromo": "عرض جديد",
  "billing.action.newDiscount": "تخفيض جديد",
  "billing.action.endNow": "إيقاف الآن",
  "billing.action.endPromo": "إيقاف العرض",
  "billing.action.endDiscount": "إيقاف التخفيض",
  "billing.action.extendSubscription": "تمديد",
  "billing.action.endSubscription": "إنهاء الاشتراك",
  "billing.dialog.setPrice.title": "تحديد سعر",
  "billing.dialog.setPrice.body": "سيسري هذا السعر على الاشتراكات الجديدة في ذلك البلد. ومن اشترك سابقًا يحتفظ بسعره.",
  "billing.dialog.newPromo.title": "عرض جديد",
  "billing.dialog.newPromo.body":
    "يحل سعر العرض محل سعر البلد خلال النافذة. ويحتفظ به المهني ما دام مشتركًا، ضمن الحد المذكور.",
  "billing.dialog.newDiscount.title": "تخفيض جديد",
  "billing.dialog.newDiscount.body":
    "اختر هدفًا واحدًا فقط: مهني أو بلد أو مهنة. ويحصل المهني على أدنى سعر فقط: التخفيض والعرض لا يُجمعان.",
  "billing.dialog.endPromo.title": "إيقاف العرض {subject}",
  "billing.dialog.endPromo.body": "لن يتمكن أحد جديد من أخذه. ومن حصل عليه يحتفظ به.",
  "billing.dialog.endDiscount.title": "إيقاف التخفيض {subject}",
  "billing.dialog.endDiscount.body": "لن يسري على الاشتراكات الجديدة. ومن حصل عليه يحتفظ به.",
  "billing.dialog.extendSubscription.title": "تمديد {subject}",
  "billing.dialog.extendSubscription.body":
    "بادرة تجارية: يمتد الوصول حتى التاريخ المختار ويُرفع الإيقاف. ولا يتغير سعر المهني.",
  "billing.dialog.endSubscription.title": "إنهاء الاشتراك {subject}",
  "billing.dialog.endSubscription.body":
    "يتوقف الوصول فورًا ويُبلَّغ المزوّد بالكف عن الخصم. لا يوجد استرداد: امنح رصيدًا من Paiements إن كان مستحقًا.",
  "billing.field.plan": "الخطة",
  "billing.field.pickPlan": "اختر خطة",
  "billing.field.country": "البلد",
  "billing.field.countryHint": "رمز من حرفين، مثل GN.",
  "billing.field.currency": "العملة",
  "billing.field.currencyHint": "رمز من ثلاثة أحرف، مثل GNF.",
  "billing.field.amount": "السعر ({currency})",
  "billing.field.validFrom": "اعتبارًا من (اختياري)",
  "billing.field.validFromHint": "اتركه فارغًا ليسري السعر فورًا. ولا يُقبل تاريخ ماضٍ.",
  "billing.field.name": "الاسم",
  "billing.field.nameHint": "ما سيراه الفريق في القائمة، مثل «إطلاق كوناكري».",
  "billing.field.startsAt": "البداية",
  "billing.field.endsAt": "النهاية",
  "billing.field.periods": "عدد الفترات (اختياري)",
  "billing.field.periodsHint": "اتركه فارغًا ليحتفظ المهني بالسعر ما دام مشتركًا.",
  "billing.field.scope": "لمن",
  "billing.field.pro": "المهني",
  "billing.field.category": "المهنة",
  "billing.field.pickCategory": "اختر مهنة",
  "billing.field.percentOff": "نسبة التخفيض",
  "billing.field.paidThrough": "التمديد حتى",
  "billing.field.paidThroughHint": "تاريخ قادم. يستمر الوصول حتى ذلك الحين.",
  "billing.problem.reason": "اذكر سببًا من {min} حرفًا على الأقل.",
  "billing.problem.plan": "اختر خطة.",
  "billing.problem.country": "اكتب رمز بلد من حرفين.",
  "billing.problem.currency": "اكتب رمز عملة من ثلاثة أحرف.",
  "billing.problem.amount": "اكتب مبلغًا أكبر من صفر.",
  "billing.problem.validFrom": "حدّد تاريخ بداية صالحًا.",
  "billing.problem.backdated": "لا يمكن أن يبدأ السعر في الماضي.",
  "billing.problem.name": "اذكر اسمًا من {min} حرفًا على الأقل.",
  "billing.problem.window": "حدّد بداية ونهاية.",
  "billing.problem.windowOrder": "يجب أن تأتي النهاية بعد البداية.",
  "billing.problem.periods": "يجب أن يكون عدد الفترات عددًا صحيحًا أكبر من صفر.",
  "billing.problem.pro": "اختر المهني المعني.",
  "billing.problem.category": "اختر مهنة.",
  "billing.problem.percentOff": "يجب أن تكون النسبة عددًا صحيحًا بين 1 و100.",
  "billing.problem.paidThrough": "حدّد تاريخ نهاية صالحًا.",
  "billing.problem.paidThroughPast": "يجب أن يكون التاريخ في المستقبل.",
  "billing.outcome.price": "سُجّل السعر: {amount}، اعتبارًا من {date}.",
  "billing.outcome.promoCreated": "أُنشئ العرض «{name}».",
  "billing.outcome.promoEnded": "أُوقف العرض «{name}». ومن حصل عليه يحتفظ به.",
  "billing.outcome.discountCreated": "أُنشئ التخفيض «{name}».",
  "billing.outcome.discountEnded": "أُوقف التخفيض «{name}». ومن حصل عليه يحتفظ به.",
  "billing.outcome.extended": "مُدِّد الاشتراك حتى {date}.",
  "billing.outcome.subscriptionEnded": "انتهى الاشتراك. قُطع الوصول ولن يخصم المزوّد مجددًا.",
  "billing.error.stale": "تغيّر هذا أثناء اطلاعك عليه. أعد التحميل ثم تحقق وأعد المحاولة.",
  "billing.error.refused": "مرفوض: أدوارك لا تشمل الخاصية المطلوبة. اطلب الوصول من مسؤول.",
  "billing.error.invalid": "مرفوض: ما أُرسل لم يعد صالحًا. أعد التحميل وتحقق.",
  "billing.error.outcomeUnknown": "لا رد من الخادم: قد يكون قد سُجّل. أعد المحاولة: النقرة نفسها لا تُطبَّق مرتين.",
  "billing.refused.planNotPriced": "مرفوض: لا سعر لهذه الخطة في ذلك البلد بعد. حدّده أولًا.",
  "billing.refused.invalidAmount": "مرفوض: يجب أن يكون المبلغ أكبر من صفر.",
  "billing.refused.backdated": "مرفوض: لا يمكن أن يبدأ السعر في الماضي.",
  "billing.refused.priceVersionExists": "مرفوض: توجد نسخة تبدأ في ذلك الوقت لهذه الخطة وهذا البلد. أعد تحميل القائمة.",
  "billing.refused.invalidWindow": "مرفوض: النافذة غير صالحة. يجب أن تأتي النهاية بعد البداية.",
  "billing.refused.alreadyOver": "مرفوض: انتهى هذا بالفعل. أعد تحميل القائمة.",
  "billing.refused.idempotencyKeyRequired": "مرفوض: أُرسل الطلب دون مفتاحه. أغلق النافذة وابدأ من جديد.",
  "billing.subscription.pending": "قيد الانتظار",
  "billing.subscription.active": "نشط",
  "billing.subscription.ending": "بلا تجديد",
  "billing.subscription.suspended": "موقوف",
  "billing.subscription.ended": "منتهٍ",
  "billing.endReason.renewal_cancelled": "ألغى المهني التجديد",
  "billing.endReason.unpaid": "تجديد غير مدفوع",
  "billing.endReason.checkout_abandoned": "لم يكتمل الدفع",
  "billing.endReason.replaced": "استُبدل باشتراك آخر",
  "billing.endReason.ended_by_staff": "أنهاه الفريق",
  "billing.endReason.ended_by_provider": "أنهاه المزوّد",
  "billing.event.payment_succeeded": "نجح الدفع",
  "billing.event.payment_failed": "فشل الدفع",
  "billing.event.subscription_ended": "انتهى الاشتراك",
  "billing.via.webhook": "إشعار من المزوّد",
  "billing.via.poll": "استعلام من واليو",
  "billing.via.return": "عودة المهني إلى التطبيق",
  "billing.via.reconcile": "مطابقة",
  "billing.result.applied": "طُبّق",
  "billing.result.conflict": "تعارض",
  "billing.result.ignored": "متجاهَل",
  "billing.priceInsteadOf": "{now} بدلًا من {regular}",
  "billing.reductionWithPeriods": "{name} · تبقّت {count} فترات",
  "billing.sub.loading": "جارٍ تحميل الاشتراك…",
  "billing.sub.loadFailed": "تعذّر تحميل الاشتراك.",
  "billing.sub.none": "لم يشترك هذا المهني قط.",
  "billing.sub.credit": "الرصيد",
  "billing.sub.noCredit": "لا شيء",
  "billing.sub.noRefunds": "لا استرداد على الاشتراك. البادرة رصيد يُمنح من Paiements ويُخصم من الدفعة التالية.",
  "billing.sub.creditLink": "مدفوعاته، لمنح رصيد ←",
  "billing.sub.discountLink": "امنح هذا المهني تخفيضًا ←",
  "billing.sub.since": "فُتح في {date}",
  "billing.sub.versionTitle": "نسخة الاشتراك المعروضة: كل عملية كتابة ترسلها.",
  "billing.sub.entitled": "الوصول مفتوح",
  "billing.sub.notEntitled": "لا وصول",
  "billing.sub.provider": "المزوّد",
  "billing.sub.renewsAutomatically": "يتجدد تلقائيًا",
  "billing.sub.paidByHand": "يدفعه المهني يدويًا",
  "billing.sub.country": "البلد",
  "billing.sub.price": "السعر الحالي",
  "billing.sub.reduction": "التخفيض",
  "billing.sub.nextPlan": "تغيير الخطة",
  "billing.sub.nextPlanValue": "ينتقل إلى {plan} في نهاية الفترة",
  "billing.sub.paidThrough": "مدفوع حتى",
  "billing.sub.renewalCancelled": "أُلغي التجديد في",
  "billing.sub.graceEnds": "مهلة السماح حتى",
  "billing.sub.ended": "انتهى في",
  "billing.sub.endReason": "سبب الانتهاء",
  "billing.sub.payments": "المدفوعات",
  "billing.sub.noPayments": "لا مدفوعات على هذا الاشتراك.",
  "billing.sub.noPeriod": "لم تُغطَّ بعد",
  "billing.sub.events": "أحداث المزوّد",
  "billing.sub.noEvents": "لا أحداث من المزوّد.",
  "billing.sub.actions": "التصرف في هذا الاشتراك",
  "billing.sub.actionsFoot": "التمديد بادرة، والإنهاء إجراء. كلاهما يتطلب سببًا ويُسجَّل في سجل التدقيق.",
} as const;
